module.exports = __webpack_public_path__ + "media/images/icon/icons8-Logout Rounded Left-2c02234651555ecd9f51265c684b6602.png";